// @flow
import React from "react";
import { push } from "connected-react-router/immutable";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import ChevronRight from "@material-ui/icons/ChevronRight";
import { List, Map } from "immutable";

type Props = {
  breadcrumbs: List<Map<string, string>>,
  color: "primary" | "secondary",
  url: string,
  redirect: (string) => void,
};

const Breadcrumbs = (props: Props) => {
  const { breadcrumbs, color, url } = props;
  let redirect = props.redirect;
  if (!redirect) {
    redirect = push;
  }
  return (
    <Grid container alignItems="center">
      <Grid item>
        <Button color={color} onClick={() => redirect(url)} size="small">
          Help
        </Button>
      </Grid>
      {breadcrumbs.map((breadcrumb, idx) => {
        return (
          <React.Fragment key={breadcrumb.get("key")}>
            <Grid item>
              <ChevronRight />
            </Grid>
            <Grid item>
              <Button
                color={color}
                onClick={() => redirect(`${url}/${breadcrumb.get("key")}`)}
                size="small"
              >
                {breadcrumb.get("title")}
              </Button>
            </Grid>
          </React.Fragment>
        );
      })}
    </Grid>
  );
};

export default Breadcrumbs;
